const plants = ['ZEDELGEM'];
function isPlantNewEwoFeatures(plantDesc) {
  return plants.includes(plantDesc);
}
function zedelgemCondition(user) {
  return (
    plants.includes(user.plantdesc) && [1, 4, 5, 8].includes(user.idprofilo)
  );
}

function croixCondition(user) {
  return user.plantdesc === 'CROIX';
}

function LecceCondition(user) {
  return user.plantdesc === 'LECCE';
}

function ModenaCondition(user) {
  return user.plantdesc === 'MODENA';
}
function ModenaBrekdowntype(value, user) {
  if (!ModenaCondition(user)) return value;
  const map = {
    '1 Partial': '1 Macchina Lavora',
    '2 Total': '2 Macchina Ferma'
  };
  return map[value] || value;
}

export {
  isPlantNewEwoFeatures,
  zedelgemCondition,
  LecceCondition,
  ModenaCondition,
  ModenaBrekdowntype,
  croixCondition
};
